import React, { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import api, { apiErrorMsg } from "@/lib/api";
import { Logo } from "@/components/Logo";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 6) { toast.error("A jelszó legalább 6 karakter legyen."); return; }
    if (pw !== pw2) { toast.error("A két jelszó nem egyezik."); return; }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password: pw });
      toast.success("Jelszó sikeresen megváltoztatva! Jelentkezz be az új jelszóval.");
      navigate("/belepes");
    } catch (err) {
      toast.error(apiErrorMsg(err.response?.data?.detail));
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-cream flex flex-col" data-testid="reset-page">
      <div className="p-6"><Link to="/"><Logo className="h-11 w-auto" /></Link></div>
      <div className="flex-1 flex items-center justify-center px-5 pb-16">
        <div className="w-full max-w-md bg-white rounded-md border border-black/5 shadow-[0_8px_30px_rgb(0,0,0,0.05)] p-8">
          <h1 className="font-serif text-3xl font-light text-ink">Új jelszó beállítása</h1>
          {!token ? (
            <p className="text-sm text-red-500 mt-3">Hiányzó vagy érvénytelen link. Kérj új jelszó-visszaállítást a belépés oldalon.</p>
          ) : (
            <form onSubmit={submit} className="space-y-4 mt-6">
              <input required type="password" placeholder="Új jelszó" value={pw} onChange={(e) => setPw(e.target.value)} data-testid="reset-password"
                className="w-full rounded-md border border-stone-200 px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-poppy/40" />
              <input required type="password" placeholder="Új jelszó megerősítése" value={pw2} onChange={(e) => setPw2(e.target.value)} data-testid="reset-password-confirm"
                className="w-full rounded-md border border-stone-200 px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-poppy/40" />
              <button type="submit" disabled={busy} data-testid="reset-submit"
                className="w-full rounded-full bg-poppy text-white py-3 text-sm hover:bg-poppy/90 transition-colors disabled:opacity-60">
                {busy ? "Kérlek várj..." : "Jelszó megváltoztatása"}
              </button>
            </form>
          )}
          <p className="mt-6 text-sm text-inkmuted text-center">
            <Link to="/belepes" className="text-poppy font-medium">Vissza a belépéshez</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
